<template>
	<div class="md-layout">
		<div class="md-layout-item">
			<md-card>
				<md-card-header class="md-card-header-icon md-card-header-blue">
					<div class="md-layout">
						<div class="md-layout-item">
							<div class="card-icon">
								<md-icon>settings</md-icon>
							</div>
							<h4 class="title">Liste des types de dispositifs</h4>
						</div>
					</div>
				</md-card-header>
				<md-card-content class="mt-2">
					<md-table v-model="deviceTypes" table-header-color="blue">
						<md-table-row slot="md-table-row" slot-scope="{ item }">
							<md-table-cell md-label="#">{{ item.id }}</md-table-cell>
							<md-table-cell md-label="">
								<img :src="item.icon" alt="picto" />
							</md-table-cell>
							<md-table-cell md-label="Nom">
								{{ item.name }}
							</md-table-cell>
							<md-table-cell md-label="Produit">
								{{ item.product ? item.product.name : 'Ø' }}
							</md-table-cell>
							<md-table-cell md-label="Quantités">
								<span>{{ quantitiesList(item) }}</span>
							</md-table-cell>
							<md-table-cell md-label="Si conso">
                                <div v-if="item.consumed">
                                    <div>Type: {{ item.consumed.device_type_id }}</div>
                                    <div v-if="item.consumed.quantity">Qt : {{ item.consumed.quantity.quantity }}</div>
                                </div>
							</md-table-cell>
							<md-table-cell md-label="Si pas conso">
                                <div v-if="item.not_consumed">
                                    <div>Type: {{ item.not_consumed.device_type_id }}</div>
                                    <div v-if="item.not_consumed.quantity">Qt : {{ item.not_consumed.quantity.quantity }}</div>
							    </div>
                            </md-table-cell>
							<md-table-cell md-label="Modèle Rapport">
								{{ item.device_report_type.id }}
							</md-table-cell>
							<md-table-cell md-label="Type Intervention Lié">
                                <md-button v-if="item.intervention_types.length > 0" class="md-info md-simple" style="width: 100%; text-align: center; padding: 0;"
                                           @click="openModal(item.intervention_types)">
                                    Voir +
                                </md-button>
                            </md-table-cell>
							<md-table-cell md-label="Catégorie">
								{{ item.category }}
							</md-table-cell>
							<md-table-cell md-label="Version">
								{{ item.version }}
							</md-table-cell>
							<md-table-cell md-label="État">
								<span :class="item.is_active ? 'text-success' : 'text-danger'">
									{{ isActive(item.is_active) }}
								</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</md-card-content>
			</md-card>
		</div>
        <md-dialog :md-active.sync="modal.isOpen" :md-fullscreen="false">
            <md-content class="px-2 my-3.5">
                <div class="px-3">
                    <p class="text-xl font-medium mb-2">Liste des types d'interventions lié</p>
                    <md-list class="md-dense overflow-y-scroll">
                        <md-list-item v-for="intervention in modal.items" :key="intervention.id"
                                      class="text-info">{{ intervention.name }}</md-list-item>
                    </md-list>
                </div>
            </md-content>
        </md-dialog>
	</div>
</template>

<script>
export default {
	name: "DeviceTypes",
	data() {
		return {
			deviceTypes: [],
            modal: {
			    isOpen: false,
			    items: [],
            }
		}
	},
	methods: {
		isActive(state) {
			return state ? "Actif" : "Inactif"
		},
		async getDeviceTypes() {
			const { data } = await this.$store.dispatch('devices/getDeviceTypes')
			this.deviceTypes = data
		},
        openModal(items) {
		    this.modal.items = items
		    this.modal.isOpen = true
        },
        quantitiesList(item) {
		    return item.quantities.map(qt => qt.quantity ).join('; ')
        }
	},
	mounted() {
		this.getDeviceTypes()
	}
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-datatable {
        max-height: 33px;
        min-height: 33px;
        width: 100%;

        .md-ripple {
            padding: 0 1rem !important;
        }

        .md-button-content {
            i {
                font-size: 1.1rem !important;
                height: 17px !important;
                width: 15px !important;
                min-width: 15px !important;
            }

            span {
                height: 17px;
                line-height: 18px;
            }
        }
    }

    .md-layout-actions.md-layout-item {
        padding-right: 0;
    }

    .md-table-cell-container {
        img {
            width: 20px;
        }
    }

    .md-list.md-dense {
        padding: 0;
        max-height: 520px;

        .md-list-item {
            margin-bottom: .25rem;
        }

        .md-list-item:last-child {
            margin-bottom: 0;
        }

        .md-list-item-content.md-ripple {
            min-height: 25px;
            padding: 0 15px;

            .md-icon {
                font-size: .875rem !important;
                min-width: .875rem !important;
                height: .875rem !important;
                color: rgba(0, 0, 0, .54) !important;
            }

            .md-icon:first-child {
                margin-right: .5rem;
            }

            .md-list-item-text {
                position: relative;
                font-size: .813rem;

                .md-button {
                    width: auto;
                    margin: 0;

                    .md-ripple {
                        min-height: 25px;
                        padding: 0 15px;

                        .md-icon {
                            color: #FFF !important;
                        }
                    }
                }

                .md-icon {
                    font-size: .875rem !important;
                    min-width: .875rem !important;
                    height: .875rem !important;
                    margin: 0;
                }

                a, span {
                    font-size: .813rem;
                }
            }
        }
    }
}
</style>
